<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-sm-3 control-label">关键字</label>
                                <div class="col-sm-9">
                                    <input type="text"  v-model="query.word" name="keyword" class="form-control" placeholder="">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <button @click="search()" type="button" class="btn btn-primary btn-sm pull-left"><i class="fa fa-search" aria-hidden="true"></i>查询</button>
                        </div>
                    </div>

                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
                                    @onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    /**
     * 志信学科查询
     */
    import tableMixin from '@/mixins/table.js';
    export default {
        mixins: [tableMixin],
        name:"SubjectList",
        components: {

        },
        data:function(){
            return {
                // 查询条件
                query:{
                    word:'',
                    zt:''
                },
                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'xkdm',
                        title: '学科代码'
                    },
                    {
                        field: 'xkmc',
                        title: '学科名称'
                    }
                ]
            }
        },
        mounted(){
            this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
            this.load();
        },
        beforeRouteUpdate(to, from, next){
            this.query = Object.assign(this.query,{current:1,size:10},to.query);
            this.load();
            next();
        },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'基础数据'},{name:'基础信息查询'},{name:'学科查询'}]);
        },
        methods: {
            search:function(){
                //将数据表格的页码以及每一页展示的数据重置为1，10
                let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
                this.$router.push({name:this.$route.name,query:query});
            },
            //返回表格数据
            load:function(pageNumber, pageSize){
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/inf/xk/cx',this.query).then(res=>{
                    let data = res.data;
                    //封装返回值
                    let result= {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
                    this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
                        pageSize:parseInt(this.query.size)});
                });
            },
            pageChange:function(pageNumber, pageSize){
                let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
                this.$router.push({name:this.$route.name,query:query});
            }
        }

    }
</script>
<style scoped>

</style>
